import { defineMessages } from '../../i18n/messages';

export const TrustStripMessages = defineMessages({
  POWERED_BY: {
    id: 'homepage.trust_strip.powered_by',
    text: 'Powered by Claude Sonnet 4.6',
    description: 'Trust badge indicating the AI model used for translations',
  },
  BUILT_ON_AWS: {
    id: 'homepage.trust_strip.built_on_aws',
    text: 'Built on AWS',
    description: 'Trust badge indicating the cloud platform',
  },
  LOCALES_SUPPORTED: {
    id: 'homepage.trust_strip.locales_supported',
    text: '56 locales supported',
    description: 'Trust badge showing number of supported locales',
  },
  SELF_LOCALIZED: {
    id: 'homepage.trust_strip.self_localized',
    text: 'This site is localized with Localingos',
    description: 'Trust badge indicating the site uses its own product',
  },
});